/**
 * [REDE] "Você está na unidade X · trocar" — atalho pra voltar à tela de
 * escolha de unidade sem perder o cliente.
 *
 * Só aparece em loja de rede com cardápio único e 2+ unidades. Fora disso não
 * renderiza nada, então pode morar fixo na gaveta e na barra lateral.
 *
 * Mostrar a unidade ATUAL importa tanto quanto o botão: o cliente que volta
 * dias depois abre direto no cardápio da unidade lembrada, e sem esse rótulo
 * ele não teria como saber de qual loja é o cardápio que está vendo.
 */
import { t, useI18n } from '../i18n';

declare global {
  interface Window {
    trocarUnidadeRede?: () => void;
  }
}

export function TrocarUnidade({ aoTrocar }: { aoTrocar?: () => void }) {
  useI18n();
  const unidades = window.NETWORK_UNITS || [];
  if (unidades.length < 2) return null;
  const atual = unidades.find((u) => u.slug === window.STORE_SLUG);
  if (!atual) return null;

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-xl p-3">
      <p className="text-[10px] font-bold uppercase tracking-wider text-gray-400 leading-none">
        {t('Unidade')}
      </p>
      <p className="text-[13px] font-black text-gray-800 mt-1 leading-tight break-words">
        {atual.name}
      </p>
      <button
        type="button"
        onClick={() => { aoTrocar?.(); window.trocarUnidadeRede?.(); }}
        className="mt-2 text-[11px] font-bold text-red-600 hover:text-red-700 transition flex items-center gap-1.5"
        style={{ WebkitTapHighlightColor: 'transparent' }}
      >
        <i className="fas fa-arrows-rotate text-[10px]" /> {t('Trocar unidade')}
      </button>
    </div>
  );
}
